import { proAccountThemeCoreUI } from '@orcha/micro-library-core-ui';
import { createTheme } from '@mui/material';

const theme = createTheme({
  ...proAccountThemeCoreUI,
  typography: { ...proAccountThemeCoreUI.typography },

  components: {
    ...proAccountThemeCoreUI.components,
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          background: proAccountThemeCoreUI.palette.common.white,
          borderBottom: '1px solid #D7D7D7',
          zIndex: 900,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          [proAccountThemeCoreUI.breakpoints.up('md')]: {
            paddingLeft: proAccountThemeCoreUI.spacing(10),
            paddingRight: proAccountThemeCoreUI.spacing(10),
          },
        },
      },
    },
  },
});

export default theme;
